export const NavExpand = () => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5024_11946)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.71429 0.142578C1.66295 0.142578 0 1.80553 0 3.85686V10.1425C0 12.1939 1.66295 13.8567 3.71429 13.8567H12.2857C14.337 13.8567 16 12.1939 16 10.1425V3.85686C16 1.80553 14.337 0.142578 12.2857 0.142578H3.71429ZM1.71429 9.85675C1.71429 11.1192 2.73763 12.1425 4 12.1425H12.2857C13.3903 12.1425 14.2857 11.247 14.2857 10.1425V3.85686C14.2857 2.7523 13.3903 1.85686 12.2857 1.85686H4C2.73763 1.85686 1.71429 2.88021 1.71429 4.14258V9.85675Z"
        fill="#706A85"
      />
      <path
        d="M10.8571 1.28516H9.14285V12.7137H10.8571V1.28516Z"
        fill="#706A85"
      />
    </g>
    <defs>
      <clipPath id="clip0_5024_11946">
        <rect
          width="16"
          height="13.7143"
          fill="white"
          transform="translate(0 0.142578)"
        />
      </clipPath>
    </defs>
  </svg>
);
